/*
 * Copyright (c) 2023-2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {VehicleBuildOptions} from './vehicleBuildOptions.model';

export class BuildToolHarness {
  harnessName: string;
  vehicleBuildOptionsList = new Array<VehicleBuildOptions>();
  errors = new Array<string>();

  constructor(harnessName: string) {
    this.harnessName = harnessName;
  }

  static sortData(harnesses: Array<BuildToolHarness>) {
    harnesses.sort((o1: BuildToolHarness, o2: BuildToolHarness) => {
      if (o1.vehicleBuildOptionsList.length == 0) {
        return 1;
      }
      if (o2.vehicleBuildOptionsList.length == 0) {
        return -1;
      }
      return o1.harnessName.localeCompare(o2.harnessName);
    });

    harnesses.forEach(function(harness){
      harness.vehicleBuildOptionsList.sort(
        (vb : VehicleBuildOptions, vb2: VehicleBuildOptions) =>
          vb.vehicleBuildId > vb2.vehicleBuildId ? 1 : -1
      );
      harness.vehicleBuildOptionsList.forEach(function(vehicleBuild) {
        vehicleBuild.commonOptions.sort((a, b) => a.localeCompare(b));
        vehicleBuild.vehicleOnlyElectricalOptions.sort((a, b) => a.localeCompare(b));
        vehicleBuild.vehicleOnlyNonElectricalOptions.sort((a, b) => a.localeCompare(b));
        vehicleBuild.harnessOnlyOptions.sort((a, b) => a.localeCompare(b));
        vehicleBuild.buildIdPartNumber = vehicleBuild.vehicleBuildId + vehicleBuild.partNumber;
      });
    });
  }
}
